import { Button } from "@/components/ui/button";
import moment from "moment";

export function AssetSummaryHandler({
  currentExport,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "asset") {
    const exportData = dataSave.asset_details.map((obj) => {
      const goodCondition = [];
      const badCondition = [];
      const totalQuantity = [];
      dataSave.assets.map((asset) => {
        if (asset.asset_detail_id == obj.id) {
          if (asset.status == "good") {
            goodCondition.push(asset);
          }
          if (asset.status == "bad") {
            badCondition.push(asset);
          }
          totalQuantity.push(asset);
        }
      });
      return {
        "Asset Name": obj.name,
        "Asset Number": obj.asset_number,
        "Good Quantity": goodCondition.length,
        "Bad Quantity": badCondition.length,
        "Total Quantity": totalQuantity.length,
      };
    });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `asset_summary_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
